import styled from 'styled-components';

export const SwitchLabel = styled.span`
  margin-left: 5px;
`;
